import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateBusinessHeader from '../business/components/CreateBusinessHeader';
import PromotionType, { PromotionTypeLabel } from './types/promotionType';
import './ChoosePromotionTypePage.css';

const TYPE_ORDER = [
  PromotionType.DISCOUNT,
  PromotionType.PROMO_CODE,
  PromotionType.CONDITIONAL,
  PromotionType.COMBINED,
];

function ChoosePromotionTypePage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/promotions');
  };

  const handleTypeClick = (typeId) => {
    navigate(`/promotions/create?type=${typeId}`);
  };

  return (
    <div className="choose-promo-type-root">
      <CreateBusinessHeader
        title="Тип акции"
        subtitle="Выберите тип акции"
        onBack={handleBack}
      />

      <main className="choose-promo-type-content">
        <div className="choose-promo-type-grid" role="list" aria-label="Типы акций">
          {TYPE_ORDER.map((typeId) => (
            <button
              key={typeId}
              type="button"
              className="choose-promo-type-circle"
              onClick={() => handleTypeClick(typeId)}
              role="listitem"
              aria-label={PromotionTypeLabel[typeId]}
            >
              <span className="choose-promo-type-circleLabel">
                {PromotionTypeLabel[typeId]}
              </span>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}

export default ChoosePromotionTypePage;
